import React from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, Typography } from '@mui/material'
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';

const UpdateAPKconfirmDialog = ({
    open,
    setOpen,
    screen,
    latestVersion,
    onUpdate
}) => {
  return (
    <Dialog
        open={open}
        onClose={() => setOpen({open: false, screen: null})}
        fullWidth
        maxWidth="sm"
    >
        <DialogContent>
            {screen?.device_details?.root_level == 'true' ? (
                <>
                    <DialogContentText>Are you sure to update APK on screen: {screen?.deviceName}? Check details</DialogContentText>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '20px',
                        my: 2
                    }}>
                        <Typography variant="subtitle1" color="warning.main">{screen?.device_details?.software}</Typography>
                        <ArrowCircleRightOutlinedIcon />
                        <Typography variant="subtitle1" color="success.main">{latestVersion?._doc?.versionName}</Typography>
                    </Box>
                    <Typography>Before you click Update button:</Typography>
                    <ul>
                        <li>It is best to be near the device during the update</li>
                        <li>The update may cause a temporary interruption in the operation of the application.</li>
                        <li>The administrator is not responsible for the consequences of the update of rooted devices.</li>
                    </ul>
                    {!screen?.isOnline || (screen?.isOnline && screen?.isInOfflineMode) ? (
                        <Typography color="error.main" align="center">Device must be online</Typography>
                    ) : null}
                </>
            ) : (
                <>
                    <DialogContentText>Screen: <b>{screen?.deviceName}</b> is not rooted. Update will require confirmation of installation</DialogContentText>
                    <Typography mt={2}>Before you click Update button:</Typography>
                    <ul>
                        <li>Stay close to the device while updating</li>
                        <li>After downloading the new version of the application, installation will begin. Confirmation will be required during the installation process. Click Update.</li>
                        <li>After successful installation, application will restart</li>
                        <li>All application permissions will be preserved</li>
                    </ul>
                </>
            )}
        </DialogContent>
        <DialogActions>
            <Button variant="outlined" color="error" onClick={() => setOpen({open: false, screen: null})}>Cancel</Button>
            <Button variant="contained" color="success" onClick={() => onUpdate(screen, latestVersion)} disabled={!screen?.isOnline || (screen?.isOnline && screen?.isInOfflineMode)}>Update!</Button>
        </DialogActions>
    </Dialog>
  )
}

export default UpdateAPKconfirmDialog
